import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const FontAwesomeIconMobileStyled = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== 'selected',
})(({ theme, selected }) => {
  const setColor = () =>
    selected
      ? theme.palette.colors.iconsSelectedOnMenu
      : theme.palette.colors.iconsOnMenuBackground;

  return {
    color: setColor(),
    height: 24,
    fontSize: 22,
  };
});
export const ListItemIconMobileStyled = styled(ListItemIcon)(() => ({
  minWidth: 'auto',
  marginTop: 8,
}));

export const DrawerMobileStyled = styled(Drawer)(() => ({
  top: 'auto',
  '.MuiPaper-root': {
    marginBottom: '71px',
    boxShadow: 'none',
  },
}));

export const LeafListItemButtonMobileStyled = styled(ListItemButton)(
  ({ theme }) => ({
    paddingLeft: '8px',
    color: 'transparent',
    height: 36,
    padding: '0 20px 0 20px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.MuiButtonBase-root.Mui-selected': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    [theme.breakpoints.down('lg')]: {
      maxWidth: 238,
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 10px 0 10px',
    },
  }),
);

export const RootListItemButtonMobileStyled = styled(ListItemButton, {
  shouldForwardProp: (prop) =>
    prop !== 'selected' && prop !== 'opened' && prop !== 'isSubMenuPopup',
})(({ theme, selected, opened, isSubMenuPopup }) => {
  const setColor = () =>
    selected
      ? theme.palette.colors.iconsSelectedOnMenu
      : theme.palette.colors.iconsOnMenuBackground;
  const setBackgroundColor = () => {
    if (selected && !opened && isSubMenuPopup)
      return theme.palette.colors.menuBackground;
    if (opened && !selected) return theme.palette.colors.hoverMenuBackground;
    if (selected) return theme.palette.colors.hoverMenuBackground;
    return theme.palette.colors.menuBackground;
  };
  const setBorderColor = () =>
    selected ? theme.palette.colors.selectedBarOnMenu : 'transparent';
  return {
    color: setColor(),
    borderBottom: `3px solid ${setBorderColor()}`,
    minHeight: '71px',

    '&.MuiButtonBase-root': {
      backgroundColor: setBackgroundColor(),
      padding: '7px 6px 0px 6px',
      flexDirection: 'column',
      alignItems: 'center',
      '&::selected': {
        backgroundColor: setBackgroundColor(),
      },
    },
    '.MuiListItemText-primary': {
      fontSize: 10,
      fontWeight: selected ? 'bold' : '500',
      lineHeight: 'normal',
      letterSpacing: 'normal',
    },
    '.MuiListItemText-root': {
      marginBottom: 0,
    },
  };
});

export const ListMobileStyled = styled(List, {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'opened',
})(({ theme, selected, opened }) => {
  const setBackgroundColor = () =>
    selected || opened
      ? theme.palette.colors.hoverMenuBackground
      : theme.palette.colors.menuBackground;

  return {
    backgroundColor: setBackgroundColor(),
    display: 'flex',
    justifyContent: 'center',
  };
});

export const ToolbarMobileStyled = styled(Toolbar)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    padding: 0,
    minHeight: 71,
  },
}));

export const LeafListItemTextMobileStyled = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'isOpen',
})(({ theme, selected, isOpen }) => {
  const setColor = () =>
    selected
      ? theme.palette.colors.selectedTextButtonMenu
      : theme.palette.colors.menuBackground;
  const setBackgroundColor = () =>
    selected
      ? theme.palette.colors.hoverMenuBackground
      : theme.palette.colors.menuBackground;
  return {
    color: theme.palette.colors.onIconsAndTextButtonsVariant,
    borderRadius: '5px',
    backgroundColor: setColor(),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: isOpen ? '62px' : '0',
    height: 20,

    '&.MuiButtonBase-root': {
      backgroundColor: setBackgroundColor(),
      padding: '8px',
      '&.Mui-selected': {
        backgroundColor: setBackgroundColor(),
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
    '&.MuiButtonBase-root.Mui-selected': {
      backgroundColor: 'transparent',
      padding: '8px',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '.MuiListItemText-primary': {
      fontSize: '10px',
      fontWeight: selected ? 'bold' : 'normal',
    },
  };
});
